import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import VideoCard from "./VideoCard";
import { Grid } from "@mui/material";
import "../Videos.css";

function VideoComponent() {
  const [videos, setVideos] = useState([]);

  const performApiCall = async (SearchTerm) => {
    // console.log(SearchTerm)
    let url = `https://79b7d29c-2a32-48a8-85f8-7296793908d1.mock.pstmn.io/vi/videos`;
    if (SearchTerm !== "") {
      url = `${url}?title=${SearchTerm}`;
    } else if (SearchTerm === "") {
      return;
    }
    const response = await axios.get(url);
    const videosReceived = response.data.videos;
    console.log("Api Call Made");
    console.log(response.data.videos);
    setVideos(videosReceived);
  };

  useEffect(() => {
    performApiCall();
  }, []);


  return <div>
    <Grid className="VideosGrid" container spacing={2}>
        {videos.map((video) => {
          const {
            videoLink,
            contentRating,
            _id,
            previewImage,
            genre,
            title,
            releaseDate,
            viewCount,
          } = video;
          return (
            <Grid item lg={3} md={4} sm={6} xs={12} key={_id}>
              <VideoCard
                videoLink={videoLink}
                key={_id}
                imgLink={previewImage}
                genre={genre}
                title={title}
                releaseDate={releaseDate}
                contentRating={contentRating}
                viewCount={viewCount}
                id={_id}
              />
            </Grid>
          );
        })}
      </Grid>
  </div>;
}

export default VideoComponent;
